(function() {
  'use strict';

  var registry = window.PooleaseSectionScripts = window.PooleaseSectionScripts || {};
  if (registry.productHeroMask) {
    registry.productHeroMask(document);
    return;
  }
  var sectionSelector = '[data-section-type="product-hero-mask"]';
  var instances = [];
  var frameRequested = false;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileLayout = window.matchMedia('(max-width: 768px)');
  var MOBILE_REVEAL_START_RATIO = 0.4;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function easeInOutCubic(value) {
    return value < 0.5
      ? 4 * value * value * value
      : 1 - Math.pow(-2 * value + 2, 3) / 2;
  }

  function measure(instance) {
    instance.sectionHeight = instance.el.getBoundingClientRect().height;
    instance.viewportHeight = instance.sticky.getBoundingClientRect().height;
    alignLineBackgrounds(instance);
    resizeVideoMask(instance);
  }

  function resizeVideoMask(instance) {
    if (!instance.videoMask) return;

    var rect = instance.videoMask.getBoundingClientRect();
    var pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
    var width = Math.max(1, Math.round(rect.width * pixelRatio));
    var height = Math.max(1, Math.round(rect.height * pixelRatio));

    if (instance.videoMask.width !== width) instance.videoMask.width = width;
    if (instance.videoMask.height !== height) instance.videoMask.height = height;
    instance.videoMaskRatio = pixelRatio;
  }

  function splitCanvasLines(context, text, maxWidth) {
    var paragraphs = String(text || '').split(/\r?\n/);
    var rows = [];

    for (var p = 0; p < paragraphs.length; p++) {
      var words = paragraphs[p].trim().split(/\s+/).filter(Boolean);
      if (!words.length) {
        rows.push('');
        continue;
      }

      var row = words[0];
      for (var i = 1; i < words.length; i++) {
        var candidate = row + ' ' + words[i];
        if (context.measureText(candidate).width <= maxWidth) {
          row = candidate;
        } else {
          rows.push(row);
          row = words[i];
        }
      }
      rows.push(row);
    }

    return rows;
  }

  function drawVideoMask(instance, coverOpacity, lineOpacities) {
    if (!instance.videoMask) return;

    resizeVideoMask(instance);
    var context = instance.videoMask.getContext('2d');
    var pixelRatio = instance.videoMaskRatio || 1;
    var canvasRect = instance.videoMask.getBoundingClientRect();
    var width = canvasRect.width;
    var height = canvasRect.height;

    context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    context.clearRect(0, 0, width, height);
    context.globalCompositeOperation = 'source-over';
    context.globalAlpha = coverOpacity;
    context.fillStyle = getComputedStyle(instance.el).getPropertyValue('--mask-color').trim() || '#ffffff';
    context.fillRect(0, 0, width, height);

    context.globalCompositeOperation = 'destination-out';

    for (var i = 0; i < instance.lines.length; i++) {
      var lineOpacity = lineOpacities[i] || 0;
      if (lineOpacity <= 0) continue;

      var line = instance.lines[i];
      var lineRect = line.getBoundingClientRect();
      var style = getComputedStyle(line);
      var fontSize = parseFloat(style.fontSize) || 16;
      var lineHeight = parseFloat(style.lineHeight) || fontSize * 1.04;
      var textAlign = style.textAlign || 'left';
      var x = lineRect.left - canvasRect.left;
      var y = lineRect.top - canvasRect.top + Math.max(0, (lineHeight - fontSize) / 2);

      context.globalAlpha = lineOpacity;
      context.font = [style.fontStyle, style.fontWeight, style.fontSize, style.fontFamily].join(' ');
      context.textBaseline = 'top';
      context.textAlign = textAlign;
      if ('letterSpacing' in context) context.letterSpacing = style.letterSpacing;

      if (textAlign === 'center') x += lineRect.width / 2;
      if (textAlign === 'right') x += lineRect.width;

      var rows = splitCanvasLines(context, line.textContent, lineRect.width);
      for (var row = 0; row < rows.length; row++) {
        context.fillText(rows[row], x, y + row * lineHeight, lineRect.width);
      }
    }

    context.globalAlpha = 1;
    context.globalCompositeOperation = 'source-over';
  }

  function alignLineBackgrounds(instance) {
    var stickyRect = instance.sticky.getBoundingClientRect();
    var containerWidth = stickyRect.width;
    var containerHeight = stickyRect.height;
    var containerAspect = containerWidth / Math.max(1, containerHeight);
    var renderedWidth;
    var renderedHeight;

    if (containerAspect > instance.imageAspect) {
      renderedWidth = containerWidth;
      renderedHeight = containerWidth / instance.imageAspect;
    } else {
      renderedHeight = containerHeight;
      renderedWidth = containerHeight * instance.imageAspect;
    }

    var imageLeft = (containerWidth - renderedWidth) * instance.imagePositionX;
    var imageTop = (containerHeight - renderedHeight) / 2;

    for (var i = 0; i < instance.lines.length; i++) {
      var line = instance.lines[i];
      if (line.classList.contains('product-hero-mask__line--solid')) continue;

      var lineRect = line.getBoundingClientRect();
      var lineLeft = lineRect.left - stickyRect.left;
      var lineTop = lineRect.top - stickyRect.top;
      line.style.backgroundSize = renderedWidth.toFixed(2) + 'px ' + renderedHeight.toFixed(2) + 'px';
      line.style.backgroundPosition =
        (imageLeft - lineLeft).toFixed(2) + 'px ' + (imageTop - lineTop).toFixed(2) + 'px';
    }
  }

  function syncVideoToggle(instance) {
    if (!instance.videoToggle || !instance.videos.length) return;
    var isPaused = instance.videos[0].paused;
    instance.videoToggle.textContent = isPaused ? 'Play' : 'Pause';
    instance.videoToggle.setAttribute(
      'aria-label',
      isPaused ? 'Play background video' : 'Pause background video'
    );
  }

  function updateVideoPlayback(instance) {
    if (!instance.videos.length) return;

    var shouldPlay = instance.videoInView && !reduceMotion.matches && !instance.videoPausedByUser;

    for (var i = 0; i < instance.videos.length; i++) {
      var video = instance.videos[i];
      if (shouldPlay && video.paused) {
        var playRequest = video.play();
        if (playRequest && playRequest.catch) playRequest.catch(function() {});
      } else if (!shouldPlay && !video.paused) {
        video.pause();
      }
    }

    syncVideoToggle(instance);
  }

  function setFinalState(instance) {
    instance.el.style.setProperty('--mask-cover-opacity', '1');
    instance.el.style.setProperty('--mask-text-opacity', '1');

    var lineOpacities = [];
    for (var i = 0; i < instance.lines.length; i++) {
      instance.lines[i].style.opacity = '1';
      instance.lines[i].style.willChange = 'auto';
      lineOpacities.push(1);
    }
    drawVideoMask(instance, 1, lineOpacities);
  }

  function render(instance) {
    if (!document.contains(instance.el)) return;

    if (reduceMotion.matches) {
      updateVideoPlayback(instance);
      setFinalState(instance);
      return;
    }

    var rect = instance.el.getBoundingClientRect();
    if (!instance.videoObserver) {
      instance.videoInView = rect.bottom > 0 && rect.top < window.innerHeight;
      updateVideoPlayback(instance);
    }
    var revealProgress;
    if (mobileLayout.matches) {
      /* Mobile is a natural-ratio media block instead of a pinned stage.
         Let the unobstructed media become fully visible before the mask text
         starts, then reveal it over the configured short distance. */
      var revealStart = window.innerHeight * MOBILE_REVEAL_START_RATIO;
      revealProgress = clamp(
        (revealStart - rect.top) / instance.mobileRevealDistance,
        0,
        1
      );
    } else {
      var scrollableDistance = Math.max(1, instance.sectionHeight - instance.viewportHeight);
      var sectionProgress = clamp(-rect.top / scrollableDistance, 0, 1);
      revealProgress = clamp(sectionProgress / instance.transitionEnd, 0, 1);
    }
    var easedReveal = easeInOutCubic(revealProgress);
    var textProgress = clamp((revealProgress - 0.08) / 0.92, 0, 1);

    instance.el.style.setProperty('--mask-cover-opacity', easedReveal.toFixed(4));
    instance.el.style.setProperty('--mask-text-opacity', textProgress.toFixed(4));

    var lineOpacities = [];
    for (var i = 0; i < instance.lines.length; i++) {
      var line = instance.lines[i];
      var lineStart = parseFloat(line.getAttribute('data-start-offset')) || 0;
      var lineProgress = clamp((textProgress - lineStart) / Math.max(0.01, 1 - lineStart), 0, 1);
      var easedLine = 1 - Math.pow(1 - lineProgress, 3);

      line.style.opacity = easedLine.toFixed(4);
      line.style.willChange = lineProgress >= 1 ? 'auto' : 'opacity';
      lineOpacities.push(easedLine);
    }

    drawVideoMask(instance, easedReveal, lineOpacities);
  }

  function renderAll() {
    frameRequested = false;
    instances = instances.filter(function(instance) {
      return document.contains(instance.el);
    });

    for (var i = 0; i < instances.length; i++) render(instances[i]);
  }

  function requestRender() {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(renderAll);
  }

  function initSection(el) {
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].el === el) return;
    }

    var transitionEnd = parseFloat(el.getAttribute('data-transition-end'));
    var mobileRevealDistance = parseFloat(el.getAttribute('data-mobile-reveal-distance'));
    var imagePosition = el.getAttribute('data-image-position') || 'center center';
    var instance = {
      el: el,
      sticky: el.querySelector('.product-hero-mask__sticky'),
      lines: el.querySelectorAll('.product-hero-mask__line'),
      videos: el.querySelectorAll('video'),
      videoMask: el.querySelector('[data-video-mask-canvas]'),
      videoToggle: el.querySelector('[data-video-toggle]'),
      videoPausedByUser: false,
      videoInView: false,
      videoObserver: null,
      imageAspect: parseFloat(el.getAttribute('data-image-aspect-ratio')) || 1.777777,
      imagePositionX: imagePosition.indexOf('left') === 0 ? 0 : (imagePosition.indexOf('right') === 0 ? 1 : 0.5),
      transitionEnd: clamp(transitionEnd || 0.7, 0.5, 0.9),
      mobileRevealDistance: clamp(mobileRevealDistance || 150, 120, 220),
      sectionHeight: 0,
      viewportHeight: 0
    };

    measure(instance);

    if (instance.videoToggle && instance.videos.length) {
      instance.videoToggle.addEventListener('click', function() {
        var video = instance.videos[0];
        if (video.paused) {
          instance.videoPausedByUser = false;
        } else {
          instance.videoPausedByUser = true;
        }
        updateVideoPlayback(instance);
      });

      for (var videoIndex = 0; videoIndex < instance.videos.length; videoIndex++) {
        instance.videos[videoIndex].addEventListener('play', function() { syncVideoToggle(instance); });
        instance.videos[videoIndex].addEventListener('pause', function() { syncVideoToggle(instance); });
      }
    }

    if (instance.videos.length && 'IntersectionObserver' in window) {
      instance.videoObserver = new IntersectionObserver(function(entries) {
        instance.videoInView = entries[0].isIntersecting;
        updateVideoPlayback(instance);
      }, { threshold: 0 });
      instance.videoObserver.observe(el);
    }

    instances.push(instance);
    render(instance);
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches(sectionSelector)) initSection(scope);

    var sections = scope.querySelectorAll ? scope.querySelectorAll(sectionSelector) : [];
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  function destroyWithin(root) {
    instances = instances.filter(function(instance) {
      var shouldDestroy = instance.el === root || (root.contains && root.contains(instance.el));
      if (shouldDestroy && instance.videoObserver) instance.videoObserver.disconnect();
      return !shouldDestroy;
    });
  }

  registry.productHeroMask = initAll;

  window.addEventListener('scroll', requestRender, { passive: true });
  window.addEventListener('resize', function() {
    for (var i = 0; i < instances.length; i++) measure(instances[i]);
    requestRender();
  }, { passive: true });

  if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', requestRender);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function() {
      for (var i = 0; i < instances.length; i++) measure(instances[i]);
      requestRender();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    destroyWithin(event.target);
  });
})();
